import { Column } from '../Column';
import { LegalDocumentItem } from './LegalDocumentItem';
import { ILegalDocumentNode } from './Types';

interface ILegalDocumentProps {
  content: ILegalDocumentNode[];
  indent?: number;
}

export const LegalDocument = ({ content, indent = 24 }: ILegalDocumentProps) => {
  return (
    <Column>
      {content.map((it) => (
        <LegalDocumentItem key={it.id} content={it} depth={0} indent={indent} />
      ))}
    </Column>
  );
};
